"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverType = void 0;
/**
 * 看板卡片封面类型
 */
var CoverType;
(function (CoverType) {
    CoverType["NONE"] = "none";
    CoverType["PAGE_COVER"] = "pageCover";
    CoverType["PAGE_CONTENT"] = "pageContent";
    CoverType["FILE_PROPERTY"] = "fileProperty";
})(CoverType = exports.CoverType || (exports.CoverType = {}));
